import React from 'react'
import PropTypes from 'prop-types'
import styles from './upsell.module.css'
import PiggyBank from '../../content/assets/piggy-bank.svg'
import Bulb from '../../content/assets/bulb.svg'
import Calculator from '../../content/assets/calculator.svg'
import Handshake from '../../content/assets/handshake.svg'

const Upsell = ({ heading, empty }) => {
  return(
    <div className={styles.wrapper}>
      {!empty && content(heading)}
    </div>
  )
}

Upsell.propTypes = {
  heading: PropTypes.string,
  empty: PropTypes.bool,
}

const content = (heading) => {
  return (
    <>
      <p className={styles.heading}>{heading}</p>
      <div className={styles.container}>
        <div className={styles.upsellItem}>
          <Bulb className={styles.upsellImage} />
          <p>Free and no obligation switching service</p>
        </div>
        <div className={styles.upsellItem}>
          <PiggyBank className={styles.upsellImage} />
          <p>Save your business money</p>
        </div>
        <div className={styles.upsellItem}>
          <Calculator className={styles.upsellImage} />
          <p>Compare business energy prices in your area</p>
        </div>
        <div className={styles.upsellItem}>
          <Handshake className={styles.upsellImage} />
          <p>We work with our partners to find you the best deal</p>
        </div>
      </div>
    </>
  )
}

export default Upsell
